import React from 'react';

const ExplicativoPanel = () => {
  
  // Estado para controlar la semana actual (fijo en semana 3 como ejemplo)
  const [currentWeek, setCurrentWeek] = React.useState(3);
  
  // Datos para el ciclo de temas con iconos únicos y colores
  const temasCiclo = [
    { semana: 1, tema: 'Fundamentos de Informática', icon: 'fa-desktop', color: '#2196F3', bgColor: 'rgba(33, 150, 243, 0.1)' },
    { semana: 2, tema: 'Windows 10', icon: 'fa-folder-open', color: '#4CAF50', bgColor: 'rgba(76, 175, 80, 0.1)' },
    { semana: 3, tema: 'Windows 10 (cont.)', icon: 'fa-folder-open', color: '#FF9800', bgColor: 'rgba(255, 152, 0, 0.1)' },
    { semana: 4, tema: 'Microsoft Word 365', icon: 'fa-file-word', color: '#9C27B0', bgColor: 'rgba(156, 39, 176, 0.1)' },
    { semana: 5, tema: 'Outlook 365', icon: 'fa-envelope', color: '#00BCD4', bgColor: 'rgba(0, 188, 212, 0.1)' },
    { semana: 6, tema: 'Navegación por Internet', icon: 'fa-globe', color: '#F44336', bgColor: 'rgba(244, 67, 54, 0.1)' }
  ];

  return (
    <div className="repaso-explicativo">
      {/* Header principal con gradiente */}
      <div className="explicativo-header-main">
        <div className="header-icon-wrapper">
          <i className="fas fa-graduation-cap"></i>
        </div>
        <div className="header-content">
          <h2>Sistema de Repaso Automático</h2>
          <p className="header-subtitle">
            <i className="fas fa-clock"></i>
            <span>Se activará automáticamente a partir del </span>
            <strong>mes 6</strong>
            <span> de tu suscripción</span>
          </p>
        </div>
      </div>

      {/* Línea de tiempo visual */}
      <div className="timeline-container">
        <h3 className="section-title">
          <i className="fas fa-calendar-alt"></i>
          Tu Progreso de Aprendizaje
        </h3>
        <div className="timeline">
          <div className="timeline-line"></div>
          
          {/* Primeros 5 meses */}
          <div className="timeline-section learning-phase">
            <div className="timeline-marker active">
              <i className="fas fa-book-reader"></i>
            </div>
            <div className="timeline-content">
              <h4>Meses 1-5: Fase de Aprendizaje</h4>
              <p>Acceso progresivo a las clases</p>
              <p>Construcción de base sólida</p>
            </div>
          </div>
          
          {/* Mes 6 en adelante */}
          <div className="timeline-section repaso-phase">
            <div className="timeline-marker future">
              <i className="fas fa-sync-alt"></i>
            </div>
            <div className="timeline-content">
              <h4>Mes 6+: Repaso Automático</h4>
              <p>Sistema inteligente de repaso</p>
              <p>8 nuevos tests cada mes</p>
            </div>
          </div>
        </div>
      </div>

      {/* Cards de información principal */}
      <div className="info-cards-grid">
        {/* Card 1: Estructura del Sistema */}
        <div className="info-card card-estructura">
          <div className="card-header">
            <div className="card-icon">
              <i className="fas fa-layer-group"></i>
            </div>
            <h3>Estructura del Sistema</h3>
          </div>
          <div className="card-content">
            <div className="estructura-item">
              <div className="item-header">
                <i className="fas fa-calendar-check"></i>
                <strong>Tests Mensuales</strong>
              </div>
              <p>A partir del mes 6, recibirás <strong>8 nuevos tests</strong> cada mes:</p>
              <ul className="tests-list">
                <li>
                  <span className="test-badge repaso">4 Tests de Repaso</span>
                  <span className="test-desc">Específicos por tema</span>
                </li>
                <li>
                <span className="test-badge general">4 Tests Generales</span>
                <span className="test-desc">Test generales del tema 1 a 6 mezclados</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 2: Ciclo de Temas - NUEVO DISEÑO */}
        <div className="info-card card-ciclo-new">
          <div className="card-header-gradient">
            <div className="card-icon-animated">
              <i className="fas fa-infinity"></i>
            </div>
            <h3>Ciclo de 6 Semanas</h3>
            <p className="ciclo-subtitle">Un tema cada semana en rotación continua</p>
          </div>
          <div className="card-content ciclo-content-new">
            {/* Timeline de ciclo horizontal */}
            <div className="ciclo-timeline-container">
              <div className="ciclo-timeline-track">
                <div className="ciclo-timeline-progress" style={{ width: `${(currentWeek / 6) * 100}%` }}></div>
              </div>
              
              <div className="ciclo-timeline-items">
                {temasCiclo.map((item, index) => {
                  return (
                    <div 
                      key={index} 
                      className={`ciclo-timeline-item 'active'`}
                    >
                      <div className="ciclo-timeline-marker" style={{ 
                        backgroundColor: item.color,
                        boxShadow: `0 0 20px ${item.color}40`
                      }}>
                        <i className={`fas ${item.icon}`}></i>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            
          </div>
        </div>

      </div>

      {/* Sistema de Vueltas - Full Width */}
      <div className="vueltas-section-full">
        <div className="card-header">
          <div className="card-icon">
            <i className="fas fa-repeat"></i>
          </div>
          <h3>Sistema de Vueltas</h3>
        </div>
        <div className="vueltas-content-full">
          <div className="vueltas-visual-full">
            <div className="vuelta-item current">
              <i className="fas fa-check-circle"></i>
              <span>1ª Vuelta</span>
              <small>Semanas 1-6</small>
            </div>
            <div className="vuelta-item future">
              <i className="fas fa-play-circle"></i>
              <span>2ª Vuelta</span>
              <small>Semanas 7-12</small>
            </div>
            <div className="vuelta-item future">
              <i className="fas fa-clock"></i>
              <span>3ª Vuelta</span>
              <small>Semanas 13-18</small>
            </div>
            <div className="vuelta-item future">
              <i className="fas fa-clock"></i>
              <span>4ª Vuelta</span>
              <small>Semanas 19-24</small>
            </div>
            <div className="vuelta-item future">
              <i className="fas fa-clock"></i>
              <span>5ª Vuelta</span>
              <small>Semanas 25-30</small>
            </div>
            <div className="vuelta-item future">
              <i className="fas fa-clock"></i>
              <span>6ª Vuelta</span>
              <small>Semanas 31-36</small>
            </div>
          </div>
          <p className="vueltas-info">
            Los tests se identifican por su número de vuelta para un mejor seguimiento
          </p>
        </div>
      </div>

      {/* Características destacadas */}
      <div className="features-section">
        <h3 className="section-title">
          <i className="fas fa-star"></i>
          Características del Sistema
        </h3>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-highlighter"></i>
            </div>
            <h4>1 Tema semanal de repaso</h4>
            <p>Cada semana se destacan el tema de repaso y su test</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-file-alt"></i>
            </div>
            <h4>Tests de Repaso</h4>
            <p>1 Test de 100 preguntas para el tema de repaso</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-check-double"></i>
            </div>
            <h4>Tests Generales</h4>
            <p>Mezcla de los temas 1 a 6</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-folder-open"></i>
            </div>
            <h4>Organización</h4>
            <p>Pestañas y filtros para fácil navegación</p>
          </div>
        </div>
      </div>

      {/* Video explicativo */}
      {/* <div className="video-section">
        <h3 className="section-title">
          <i className="fas fa-play-circle"></i>
          Video Explicativo del Sistema
        </h3>
        <div className="video-container">
          <iframe 
            width="100%" 
            height="450" 
            src="https://www.youtube.com/embed/VIDEO_ID_AQUI" 
            title="Sistema de Repaso Automático - Tutorial" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen>
          </iframe>
        </div>
      </div> */}

      {/* Call to action */}
      <div className="cta-section">
        <div className="cta-content">
          <i className="fas fa-rocket cta-icon"></i>
          <h3>¡Prepárate para el éxito!</h3>
          <p>
            Mientras tanto, continúa con tu aprendizaje en los primeros 5 meses. 
            El Sistema de Repaso Automático te ayudará a consolidar todos tus conocimientos 
            cuando llegue el momento.
          </p>
          <div className="time-remaining">
            <i className="fas fa-hourglass-half"></i>
            <span>El sistema se activará automáticamente cuando alcances el mes 6</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExplicativoPanel;